import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { BusinessPartnerDto } from 'api';

import { MaintenancePlannerState } from './Types';

const initialState: MaintenancePlannerState = {
	pageIndex: 0,
	isFilterAlertActive: false,
};

export const maintenancePlannerSlice = createSlice({
	name: 'maintenancePlanner',
	initialState,
	reducers: {
		resetBusinessPartner: (state) => {
			state.businessPartner = undefined;

			return state;
		},
		setBusinessPartner: (
			state,
			{ payload }: PayloadAction<BusinessPartnerDto>
		) => {
			state.businessPartner = payload;

			return state;
		},
		setIsActiveCampaign: (state, { payload }: PayloadAction<boolean>) => {
			state.isActiveCampaign = payload;

			return state;
		},
		setIsRelocated: (state, { payload }: PayloadAction<boolean>) => {
			state.isRelocated = payload;

			return state;
		},
		setIsActiveServiceAgreements: (
			state,
			{ payload }: PayloadAction<boolean>
		) => {
			state.isActiveServiceAgreements = payload;

			return state;
		},
		setIsHealthCheck: (state, { payload }: PayloadAction<boolean>) => {
			state.isHealthCheck = payload;

			return state;
		},
		setIsLatestServiceProtocol: (
			state,
			{ payload }: PayloadAction<boolean>
		) => {
			state.isLatestServiceProtocol = payload;

			return state;
		},
		filterAlertActiveChanged: (
			state,
			{ payload }: PayloadAction<boolean>
		) => {
			state.isFilterAlertActive = payload;
		},
		setNextPage: (state) => {
			state.pageIndex += 1;

			return state;
		},
		setPreviousPage: (state) => {
			if (state.pageIndex > 0) {
				state.pageIndex -= 1;
			}

			return state;
		},
	},
});

export const {
	resetBusinessPartner,
	setBusinessPartner,
	setIsActiveCampaign,
	setIsRelocated,
	setIsActiveServiceAgreements,
	setIsHealthCheck,
	setIsLatestServiceProtocol,
	filterAlertActiveChanged,
	setNextPage,
	setPreviousPage,
} = maintenancePlannerSlice.actions;

export default maintenancePlannerSlice.reducer;
